<template>
  <div>
    <v-container>
      <v-layout align-center justify-center>
        <v-card height="400" color="transparent" flat>
          <div class="subheading secondary--text text--darken-1">
            {{ $t('payment.do_not_close_the_page') }}
          </div>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'CompanyPostPaymentRedirection',
  mounted() {
    window.top.postMessage('3DS-authentication-complete');
  },
};
</script>
